var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "search-wrapper" }, [
    _c("div", { staticClass: "input-container" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text"
          }
        ],
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.text },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleSearchButtonClick.apply(null, arguments)
          },
          input: function($event) {
            if ($event.target.composing) return
            _vm.text = $event.target.value
          }
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/drc/assets/images/search.png"),
          alt: "search"
        },
        on: { click: _vm.handleSearchButtonClick }
      })
    ]),
    _c(
      "div",
      {
        staticClass: "filter-icon-container",
        on: { click: _vm.handleSearchButtonClick }
      },
      [
        _c("span", { staticClass: "filter-icon-text" }, [
          _vm._v(" " + _vm._s(_vm.$t("managementLabels.search")) + " ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }